/**
 * @file LookWarningNote.tsx
 * @description Предупреждение об оформлении под самим полем (phase19.16,
 * партия SB120, этап 1; uiux-sb120-stage1 §6 — «предупреждения, не
 * запреты»): берёт из формы секции предупреждения `sectionLookWarnings` по
 * путям поля и показывает жёлтой полосой; справочные
 * (`LOOK_WARNING_REFERENCE_CODES`, «проверьте на канве») — серой
 * подсказкой. Сохранить и опубликовать можно.
 */

import { NoticeStrip } from "../../../ui/NoticeStrip";
import { FieldHint } from "../../../ui/settings-groups";
import { useSectionForm } from "../section-form-context";
import { isReferenceWarning, lookWarningText, uniqueByText, warningsAtPaths } from "../../../../lib/site-builder/look-warnings";

interface Props {
  paths: readonly string[];
  /** Ширина файла по пути предупреждения — для «Фото N px уже кадра …». */
  fileWidthOf?: (path: string) => number | null | undefined;
}

export function LookWarningNote({ paths, fileWidthOf }: Props) {
  // Пара полей «слева и справа» — одно и то же предупреждение показываем один раз.
  const found = uniqueByText(warningsAtPaths(useSectionForm().lookWarnings, paths));
  if (found.length === 0) return null;
  return (
    <>
      {found.map((w) =>
        isReferenceWarning(w) ? (
          <FieldHint key={`${w.code}-${w.path}`} className="mt-0">
            {lookWarningText(w)}
          </FieldHint>
        ) : (
          <NoticeStrip key={`${w.code}-${w.path}`} tone="warning">
            {lookWarningText(w, { fileWidth: fileWidthOf?.(w.path) })}
          </NoticeStrip>
        ),
      )}
    </>
  );
}
